import { useLocation } from 'react-router';

export function usePathnameMatch(regexes: RegExp[]): boolean {
  const location = useLocation();

  return regexes.some((regex) => location.pathname.match(regex));
}
